import React from 'react';
import { LuShield, LuUsers, LuTrendingUp, LuSparkles } from 'react-icons/lu';
import { COPY } from '../../contracts/copyMap';

// 4-cell feature strip pinned at the bottom of marketing surfaces
// (design-recreation). Translucent bg so the hero portrait shows through.
// Acceptable here ONLY because we're on a marketing/auth surface (the
// in-app shell never gets a feature grid).
//
// Cell separators: hairline left borders on desktop (4-col), hairline top
// borders when the grid wraps to 2-col / 1-col.
const CELL_BORDERS = [
  '',
  'border-t sm:border-t-0 sm:border-l',
  'border-t lg:border-t-0 lg:border-l',
  'border-t sm:border-l lg:border-t-0',
];

const FooterFeatureStrip = ({ className = '' }) => {
  const features = [
    {
      name: COPY.MARKETING_FOOTER_PRIVATE_NAME,
      body: COPY.MARKETING_FOOTER_PRIVATE_BODY,
      icon: <LuShield size={24} />,
    },
    {
      name: COPY.MARKETING_FOOTER_COMMUNITY_NAME,
      body: COPY.MARKETING_FOOTER_COMMUNITY_BODY,
      icon: <LuUsers size={24} />,
    },
    {
      name: COPY.MARKETING_FOOTER_TRACK_NAME,
      body: COPY.MARKETING_FOOTER_TRACK_BODY,
      icon: <LuTrendingUp size={24} />,
    },
    {
      name: COPY.MARKETING_FOOTER_SECURE_NAME,
      body: COPY.MARKETING_FOOTER_SECURE_BODY,
      icon: <LuSparkles size={24} />,
    },
  ];
  return (
    <footer
      className={[
        'relative z-10 border-t border-[rgba(255,255,255,0.08)] bg-[rgba(0,0,0,0.72)]',
        'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {features.map((f, i) => (
        <div
          key={f.name}
          className={[
            'flex items-center gap-4 px-6 py-5 lg:px-9 lg:py-6',
            CELL_BORDERS[i],
            i > 0 ? 'border-hairline-soft' : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          <span className="text-aurum shrink-0" aria-hidden="true">
            {f.icon}
          </span>
          <span className="flex flex-col">
            <span
              className="font-display uppercase text-[#E8B96A]"
              style={{ fontSize: 12, letterSpacing: '0.2em' }}
            >
              {f.name}
            </span>
            <span
              className="font-display text-[#B8B2A6] mt-0.5"
              style={{ fontSize: 15 }}
            >
              {f.body}
            </span>
          </span>
        </div>
      ))}
    </footer>
  );
};

export default FooterFeatureStrip;
